<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="add-article-dialog"
  >
    <msg-reply-form
      :form-data="formData"
      ref="outform"
      @submit="submit"
    ></msg-reply-form>
  </sliderBarDialogShell>
</template>

<script>
import msgReplyForm from "@/components/wx/msg-reply-rule/msgReplyForm";

import { updateMsgReply } from "@/api/wx/msgReply";

export default {
  name: "editMsgReplyDialog",
  components: {
    msgReplyForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },

  data() {
    return {
      title: '编辑自动回复规则'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {

      updateMsgReply(form).then(({data}) => {

        this.$message({
          message: '编辑 成功',
          type: 'success',
        });
        this.$refs.outform.selfClear();
        this.$emit('edit-success');
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-article-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>

